import React from "react";
import { useSelector } from "react-redux";
import { Redirect, Route, Switch } from "react-router-dom";
import Header from "../components/header";
import { Path } from "../constants/enum/path.emum";
import Error404 from "../pages/404/404";
import Curriculum from "../pages/curriculum/curriculum";
import CurriDetail from "../pages/curriculum/curriculumDetail";
import Doc7 from "../pages/doc7/doc7";
import Downloads from "../pages/downloads/downloads";
import DashboardUser from "../pages/home/dashboard";
import Login from "../pages/login";
import FindDoc from "../pages/member/findDoc/findDoc";
import FindDoc2 from "../pages/member/findDoc/findDoc2";
import MemberInfo from "../pages/member/info/memberInfo";
import Profile from "../pages/profile/prifile";
import ReportCurri from "../pages/report/reportCurri";
import ReportDashboard from "../pages/report/reportDashboard";
import ReportDoc3 from "../pages/report/reportDoc3";
import ReportDoc5 from "../pages/report/reportDoc5";
import Schedule from "../pages/schedule/schedule";
import SettingSchedule from "../pages/schedule/setting/settingSchedule";
import SendDoc3 from "../pages/send/doc3/sendDoc3";
import Doc5 from "../pages/send/doc5/doc5";
import SendDoc from "../pages/send/senddoc";
import Setting from "../pages/setting/setting";
import Summary from "../pages/summary/summary";
import Test from "../pages/test";
import Users from "../pages/users/users";
import PrivateRoute from "./PrivateRoute";
import PublicRoute from "./PublicRoute";
import Verifi from "../pages/verification/verify";

const RouteApp: React.FC = () => {
  // const isAuthenticated = false;
  const isAuthenticated = useSelector((state: any) => state.me.isAuthenticated);
  return (
    <>
      {isAuthenticated && <Header />}
      <Switch>
        <PublicRoute path={Path.LOGIN} isAuthenticated={isAuthenticated}>
          <Login />
        </PublicRoute>

        <PrivateRoute path={Path.HOME} isAuthenticated={isAuthenticated} exact>
          <DashboardUser />
        </PrivateRoute>
        <Route path="/" exact>
          <Redirect to={"/info"} />
        </Route>
        <Route path={"/test"} exact component={Test} />
        {/* //////////Users////////////// */}
        <PrivateRoute path={Path.USERS} isAuthenticated={isAuthenticated} exact>
          <Users />
        </PrivateRoute>
        {/* //////////CURRICULUMS////////////// */}
        <PrivateRoute
          path={Path.CURRICULUMS}
          isAuthenticated={isAuthenticated}
          exact
        >
          <Curriculum />
        </PrivateRoute>
        <PrivateRoute
          path={`${Path.CURRICULUMS_DETAIL}/:id`}
          isAuthenticated={isAuthenticated}
          exact
        >
          <CurriDetail />
        </PrivateRoute>
        {/* //////////REPORT////////////// */}
        <PrivateRoute
          path={Path.REPORT}
          isAuthenticated={isAuthenticated}
          exact
        >
          <ReportDashboard />
        </PrivateRoute>
        <PrivateRoute
          path={Path.REPORT_CRRRI}
          isAuthenticated={isAuthenticated}
          exact
        >
          <ReportCurri />
        </PrivateRoute>
        <PrivateRoute
          path={Path.REPORT_CRRRI_DOC3}
          isAuthenticated={isAuthenticated}
          exact
        >
          <ReportDoc3 />
        </PrivateRoute>
        <PrivateRoute
          path={Path.REPORT_DOC5}
          isAuthenticated={isAuthenticated}
          exact
        >
          <ReportDoc5 />
        </PrivateRoute>

        {/* ////////// Verification ////////////// */}
        <PrivateRoute
          path={Path.VERIFI}
          isAuthenticated={isAuthenticated}
          exact
        >
          <Verifi />
        </PrivateRoute>

        {/* //////////////////////////// */}
        {/* ////////// สำหรับสิทธิ์ user////////////// */}
        <PrivateRoute
          path={`${Path.SENDDOC}/:scheId`}
          isAuthenticated={isAuthenticated}
          exact
        >
          <SendDoc />
        </PrivateRoute>
        <PrivateRoute
          path={`${Path.SENDDOC}/:scheId/:curriId`}
          isAuthenticated={isAuthenticated}
          exact
        >
          <SendDoc3 />
        </PrivateRoute>
        <PrivateRoute path={Path.DOC5} isAuthenticated={isAuthenticated} exact>
          <Doc5 />
        </PrivateRoute>
        <PrivateRoute
          path={`${Path.MEMBER_INFO}`}
          isAuthenticated={isAuthenticated}
          exact
        >
          <MemberInfo />
        </PrivateRoute>
        <PrivateRoute
          path={`${Path.FINDDOC}`}
          isAuthenticated={isAuthenticated}
          exact
        >
          <FindDoc />
        </PrivateRoute>
        <PrivateRoute
          path={`${Path.FINDDOC}2`}
          isAuthenticated={isAuthenticated}
          exact
        >
          <FindDoc2 />
        </PrivateRoute>
        {/* //////////SCHEDULES////////////// */}
        <PrivateRoute
          path={Path.SCHEDULES}
          isAuthenticated={isAuthenticated}
          exact
        >
          <Schedule />
        </PrivateRoute>
        <PrivateRoute
          path={Path.SCHEDULES_SETTING}
          isAuthenticated={isAuthenticated}
          exact
        >
          <SettingSchedule />
        </PrivateRoute>
        <PrivateRoute
          path={Path.PROFILE}
          isAuthenticated={isAuthenticated}
          exact
        >
          <Profile />
        </PrivateRoute>

        <PrivateRoute path={Path.DOC7} isAuthenticated={isAuthenticated} exact>
          <Doc7 />
        </PrivateRoute>
        <PrivateRoute
          path={Path.SETTINGS}
          isAuthenticated={isAuthenticated}
          exact
        >
          <Setting />
        </PrivateRoute>

        <PrivateRoute
          path={Path.DOWNLOADS}
          isAuthenticated={isAuthenticated}
          exact
        >
          <Downloads />
        </PrivateRoute>

        <PrivateRoute
          path={Path.SUMMARY}
          isAuthenticated={isAuthenticated}
          exact
        >
          <Summary />
        </PrivateRoute>

        <Route component={Error404} />
      </Switch>
    </>
  );
};

export default RouteApp;
